import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';

export const Compliance = () => {
    const { t } = useTranslation();

    const badges = [
        {
            name: 'HIPAA',
            src: '/compliance-hipaa.png',
            alt: 'HIPAA Compliant'
        },
        {
            name: 'SOC 2',
            src: '/compliance-soc2.png',
            alt: 'AICPA SOC 2'
        },
        {
            name: 'GDPR',
            src: '/compliance-gdpr.png',
            alt: 'GDPR Compliant'
        },
        {
            name: 'PIPEDA',
            src: '/compliance-pipeda.png',
            alt: 'PIPEDA Compliant'
        }
    ];

    return (
        <section className="py-12 bg-gray-50 border-t border-gray-100">
            <div className="container mx-auto px-4">
                <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
                    {/* Text Content */}
                    <div className="lg:max-w-md">
                        <p className="text-gray-600 mb-4">
                            {t('compliance.description')}
                        </p>
                        <a
                            href="#"
                            className="inline-flex items-center text-gray-900 font-medium hover:text-primary transition-colors group"
                        >
                            {t('compliance.learnMore')}
                            <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                        </a>
                    </div>

                    {/* Compliance Badges */}
                    <div className="flex flex-wrap items-center justify-center gap-8 lg:gap-12">
                        {badges.map((badge, index) => (
                            <div key={index} className="flex flex-col items-center">
                                <img
                                    src={badge.src}
                                    alt={badge.alt}
                                    className="h-16 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};
